import { array, boolean, nullable, number, object, string } from "superstruct";

import { ProductImageSchema } from "./ProductImageSchema";
import { ProductPriceSchema } from "./ProductPriceSchema";

export const ProductVariantSchema = object({
    id: number(),
    title: string(),
    price: ProductPriceSchema,
    compareAtPrice: nullable(ProductPriceSchema),
    quantityAvailable: number(),
    currentlyNotInStock: boolean(),
    availableForSale: boolean(),
    image: nullable(ProductImageSchema),
    options: array(
        object({
            name: string(),
            value: string(),
        })
    ),
});
